module.exports = __webpack_public_path__ + "img/down_arrow_white.80145bbb.webp";